import { render, staticRenderFns } from "./nurseAdd.vue?vue&type=template&id=380d6d89&scoped=true&"
import script from "./nurseAdd.vue?vue&type=script&lang=js&"
export * from "./nurseAdd.vue?vue&type=script&lang=js&"
import style0 from "./nurseAdd.vue?vue&type=style&index=0&id=380d6d89&lang=scss&scoped=true&"
import style1 from "./nurseAdd.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d6d89",
  null
  
)

export default component.exports